module.exports = __webpack_public_path__ + "static/media/Anatomy-of-Battery-New.e5b41187.png";